import { request } from '@umijs/max';

export type StaticIconGroup = 'industries' | 'business-districts';

export interface StaticIconItem {
  name: string;
  path: string; // backend-relative path like /static/icons/.../*.png
}

export async function getStaticIcons(group: StaticIconGroup) {
  return request<{
    code: number;
    message: string;
    data: StaticIconItem[];
  }>(`/api/admin/static-icons/${group}`);
}

